module.exports = __webpack_public_path__ + "media/chuku2.44a0b7fe.wav";